import apiFetch from '../apiFetch'

export default function (dossierId, code, token) {
  return apiFetch({ endPoint: `Margin/${dossierId}/Approve/${code}`, method: 'PUT', body: null, token: token })
}
